import { MessageBoxCheckDialog } from '../message-box-check/message-box-check.component';
import { Component, OnInit, ElementRef } from '@angular/core';
import { MdDialog, MdDialogRef } from '@angular/material';
import { MessageBoxDialog } from '../message-box/message-box.component';
import { Router } from '@angular/router';
import { ActivatedRoute } from '@angular/router';
import { MapComponent } from '../map/map.component';
import { JobsOffer } from '../../models/jobs-offer';

import { LanguageLevelService } from '../../services/language-level.service';
import { LanguageNameService } from '../../services/language-name.service';
import { JobOffersService } from '../../services/job-offers.service';
import { JobCategoriesService } from '../../services/job-categories.service';
import { VenueService } from '../../services/venue.service';
import { EducationLevelService } from '../../services/educationlevel.service';
import { ContractTypeService } from '../../services/contracttype.service';
import { JobTypeService } from '../../services/jobtype.service';
import { AuthService } from '../../services/auth.service';
import { FormComponent } from '../form/form.component';
import { FilesComponent } from '../files/files.component';
import { FormService } from '../../services/form.service';
import { FilesService } from '../../services/files.service';
import { Form, PaginatedForms} from '../../models/form';
import { FileList, PaginatedDocList} from '../../models/file';
import { VenueCompleterComponent } from '../venue-completer/venue-completer.component';
import {PaymentService} from '../../services/payment.service';
import { PaymentDialogComponent } from '../payment-dialog/payment-dialog.component';
import { ConfigurationService } from '../../services/configuration.service';
import { TourService, IStepOption } from 'ngx-tour-ngx-bootstrap'; 
//import { TourService, IStepOption } from 'ngx-tour-ngx-popper';
import * as esLocale from "date-fns";
import { months } from 'moment';
import { StepsModule, Steps } from '../../../../node_modules/primeng/primeng';

@Component({
  selector: 'app-create-offer',
  templateUrl: './create-offer.component.html',
  styleUrls: ['./create-offer.component.css']
})

export class CreateOfferComponent implements OnInit {
  company_type: string;
  publicating: boolean = false;
  register: boolean = false;
  selectedOption: string;
  statusSalary: number = 1;
  gender: number = 1;
  disability: number = 1;
  jobsOffer: JobsOffer;
  jobsOfferCopy: JobsOffer;
  jobs: any;
  jobCategories: any;
  venues: any;
  educationLevel: any;
  contractType: any;
  jobType: any;
  languageName: any;
  languageLevel: any;
  listLang = [];
  listExtras = [];
  listForms = [];
  textExtra: string = "";
  requiredExtra: boolean;
  id: string;
  reqId: string;
  private sub: any;
  dateValid: boolean = true;
  errorMessage: string;
  jobcategorysel: string;
  company_name: string;
  view: boolean;
  forms: PaginatedForms;
  filelist: PaginatedDocList;
  page: number = 1;
  total: number = 0;
  totalfl: number = 0;
  max: number = 1000;
  premium:string;
  files:string;
  venue_id:string;
  venue_name:string;
  InvalidVacancy: boolean = true;
  minTransactions:number = 1;
  venue_real_id:number;
  loading: boolean;
  checkOnchange: boolean = false;
  transactions: any;
  totalTransactions: number = 0;

  languageList: {id: number, name: string}[];
  levelList: {id: number, level: string, name: string, description: string}[];

  currentDate = this.yesterday();

  es: any;

  date: Date;
  date2: Date;
  dateMax: Date;

  // myDatePickerOptionsA: IMyOptions = {
  //   // other options...
  //   disableUntil: {
  //     year: this.currentDate.getFullYear(),
  //     month: this.currentDate.getMonth() + 1,
  //     day: this.currentDate.getDate()
  //   },
  //   dateFormat: 'yyyy-mm-dd',
  //   height: '30px',
  //   width: '230px',
  // };

  // myDatePickerOptionsB: IMyOptions = {
  //   // other options...
  //   dateFormat: 'yyyy-mm-dd',
  //   height: '30px',
  //   width: '230px',
  // };

  constructor(private _router: Router,
              public dialog: MdDialog,
              private route: ActivatedRoute,
              private languageNameService: LanguageNameService,
              private languageLevelService: LanguageLevelService,
              private jobService: JobOffersService,
              private jobCategoriesService: JobCategoriesService,
              private venueService: VenueService,
              private educationLevelService: EducationLevelService,
              private contractTypeService: ContractTypeService,
              private jobTypeService: JobTypeService,
              private auth: AuthService,
              private formService: FormService,
              private filesService: FilesService,
              public paymentService: PaymentService,
              private configurationService: ConfigurationService,
              public tourService: TourService
            ) {
              this.loading = true;
              if (route.snapshot.url[0].path == 'viewoffer')  {
                this.view = true;
              } else {
                this.view = false;
              }
              this.tourService.initialize$.subscribe((steps: IStepOption[]) => {
                console.log('tour configured with these steps:', steps);
              }); 
              
               this.tourService.initialize([{
                anchorId: 'vista',
                content: 'En el cuadro inferior puedes ver cómo tu oferta se carga en la aplicación.',
                placement: 'top',
                title: 'Vista Previa',
              }, {
                anchorId: 'Oferta-Privada',
                content: 'Crea convocatorias internas o privadas, esta oferta no la verán los candidatos a menos que los invites a ser parte del proceso.',
                placement: 'bottom',
                title: 'Oferta Privada',
                stepId: 'Oferta-Privada',
              }, {
                anchorId: 'Oferta-Urgente',
                content: 'Activa el botón para que tu oferta se vea en una sección especial en DreamJobs App.',
                placement: 'right',
                title: 'Oferta Urgente',
              }, {
                anchorId: 'Solicitar-Documentos',
                content: 'Activa el botón para que puedas solicitar documentos, podrás especificar los documentos.',
                placement: 'top',
                title: 'Solicitar Documentos',
              }, {
                anchorId: 'Requisitos-Obligatorios',
                content: 'Realiza preguntas de única respuesta (Sí/No) nosotros perfilamos por ti a los candidatos que cumplen el 100% de los requisitos obligatorios establecidos.',
                title: 'Requisitos Obligatorios y Deseables',
              }, {
                anchorId: 'Formulario-Preguntas',
                content: 'Entrevista miles de candidatos al tiempo sin tener que realizar una llamada, podrás ver las respuestas en su hoja de vida.',
                title: 'Formulario de Preguntas Entrevista Virtual',
              }//, {
              //   anchorId: 'another.route',
              //   content: 'Like this!',
              //   route: 'ngx-bootstrap/other',
              //   title: 'Another Route',
              // }//, {
              //   anchorId: 'config.route',
              //   content: 'And then back again.',
              //   placement: 'bottom',
              //   title: 'Route Return',
              // }, {
              //   anchorId: 'config.placement.default',
              //   content: 'Steps can be positioned around an anchor. You can even have multiple steps use the same anchor.',
              //   title: 'No Placement',
              // }, {
              //   anchorId: 'config.placement.default',
              //   content: 'Sliiide to the left.',
              //   placement: 'left',
              //   title: 'Left Placement',
              // }, {
              //   anchorId: 'config.placement.default',
              //   content: 'Sliiide to the right.',
              //   placement: 'right',
              //   title: 'Right Placement',
              // }, {
              //   anchorId: 'config.placement.default',
              //   content: 'Take it back now y\'all.  One hop this time.',
              //   placement: 'bottom',
              //   title: 'Bottom Placement',
              // }, {
              //   anchorId: 'config.buttons.custom',
              //   content: 'You can set custom step button names',
              //   title: 'Button Titles',
              //   //prevBtnTitle: 'My Prev',
              //   //nextBtnTitle: 'My Next',
              //   //endBtnTitle: 'My End'
              // }, {
              //   anchorId: 'hotkeys',
              //   content: 'Try using the hotkeys to navigate through the tour.',
              //   title: 'Hotkeys',
              // }, {
              //   anchorId: 'events',
              //   content: 'You can subscribe to events',
              //   title: 'Events',
              ],
                {
                 prevBtnTitle: 'Anterior',
                 nextBtnTitle: 'Siguiente',
                 endBtnTitle: 'Finalizar'
                }
              );
              //this.tourService.start();
}

  ngOnInit() {
    // if (localStorage.getItem('premium')){
    //   this.premium = localStorage.getItem('premium');
    // } else {
    //   this.premium = '0';
    // }
    this.premium = '1';

    this.es = {
      firstDayOfWeek: 1,
      dayNames:["domingo","lunes","martes","miércoles","jueves","viernes","sábado" ],
      dayNamesShort: [ "dom","lun","mar","mié","jue","vie","sáb" ],
      monthNames: [ "enero","febrero","marzo","abril","mayo","junio","julio","agosto","septiembre","octubre","noviembre","diciembre" ],
      monthNamesShort: [ "ene","feb","mar","abr","may","jun","jul","ago","sep","oct","nov","dic" ],
      dateFns: esLocale
    };

    if (localStorage.getItem('files')) {
      this.files = localStorage.getItem('files');
    } else {
      this.files = '0';
    }

    if (this.premium=='1') {
      this.getForms();
    }

    this.getListFiles();
    this.refreshConfiguration();

    this.configurationService.configuration$.subscribe(
      response => {
        if (response) {
          this.refreshConfiguration();
        } else {
          this.company_name = '';
        }
        // this.dialog.open(MessageBoxDialog, {data: {message: "No se pudo conectar con el servidor, Problemas de conexión con internet", success:true, showIcon:true}});
      }
    );

    this.initOffer();
    // this.onChangePremium(true);
    this.sub = this.route.params.subscribe(params => {
      this.id = params['id'];
      this.reqId = params['reqId'];
      if (typeof this.id != 'undefined') {
        this.getOffers(this.id);
      }
    });

    this.searchTransactions();
    this.getJobCategories();
    // this.getVenues();
    this.getEducationLevel();
    this.getContractType();
    this.getJobType();
    this.getLanguageName();
    this.getLanguageLevel();
  }

  refreshConfiguration() {
    if (localStorage.getItem('company_name')) {
      this.company_name = localStorage.getItem('company_name');
      this.company_type = localStorage.getItem('type');
    } else {
      this.company_name = '';
      this.company_type = localStorage.getItem('type');
    }
  }

  getVenue($event){
    this.venue_id = $event.id;
    this.venue_real_id = $event.real_id;
    this.venue_name = $event.name;
    this.jobsOffer.venue.id = this.venue_id;
    this.jobsOffer.venue_id = this.venue_id;

    this.jobsOffer.venue.name = $event.name;
    this.jobsOffer.venue.lat = $event.lat;
    this.jobsOffer.venue.lng = $event.lng;
    this.jobsOffer.venue.address = $event.address;
  }

  private yesterday() {
    let currentDate = new Date();
    currentDate.setDate(currentDate.getDate() - 1);

    return currentDate;
}

  _keyPressNumberPositive(event: any) {
    this.InvalidVacancy = this.getInvalidVacancy();
    this.totalTransactions = this.totalTransactions;
    const pattern = /[0-9\ ]/;
    let inputChar = String.fromCharCode(event.charCode);
    if (!pattern.test(inputChar)) {
      event.preventDefault();
    }
  }

  _keyPressNumber(event: any) {
    const pattern = /[0-9\+\-\ ]/;
    let inputChar = String.fromCharCode(event.charCode);
    if (!pattern.test(inputChar)) {
      event.preventDefault();
    }
  }

  _keyPressLetter(event: any) {
    const pattern = /^[a-zA-Z]+$/;
    let inputChar = String.fromCharCode(event.charCode);
    if (!pattern.test(inputChar)) {
      event.preventDefault();
    }
  }

  onDateChanged() {
    console.log("hola");
    this.date2 = new Date(this.date.getFullYear(), this.date.getMonth(), this.date.getDate() + 30);
    console.log(this.date2);
  }

  getJobCategories() {
    this.jobCategoriesService.getJobCategories()
      .subscribe(
        data => {
          this.jobCategories = data.jobcategories;
        },
        error => this.errorMessage = <any>error
      );
  }

  searchTransactions (page?: number, query?: string, active?: boolean, deleted?: boolean) {
    this.loading = true;

    this.page = page;
    if (page == null) {
      page = 1;
    }

    const status = 1;
    this.paymentService.getTransaction(page, this.max, status)
    .subscribe(
    data => {
      this.transactions = data.transaction;
      this.totalTransactions = data.pagination.total;
      this.loading = false;
    },
    error => {
      if (error.status == 404) {
        this.transactions = undefined;
        this.totalTransactions = 0;
        this.loading = false;
      } else {
        console.log(error);
        this.transactions = undefined;
        this.totalTransactions = 0;
        this.loading = false;
      }
    });
  }

  // getVenues() {
  //   this.venueService.getVenues()
  //     .subscribe(
  //       data => {
  //         this.venues = data;
  //       },
  //       error => this.errorMessage = <any>error
  //     );
  // }

  getForms() {
    this.formService.getForms(this.page, this.max)
    .subscribe(
    data => {
      this.forms = data.forms;
      this.total = data.pagination.total;
    },
    error => {
      if (error.status == 404) {
        this.forms = undefined;
      } else {
        console.log(error);
        this.forms = undefined;
      }
    });
  }

  getListFiles() {
    this.filesService.getDoclists(this.page, this.max)
    .subscribe(
    data => {
      this.filelist = data.doclists;
      this.totalfl = data.pagination.total;
    },
    error => {
      if (error.status == 404) {
        this.filelist = undefined;
      } else {
        console.log(error);
        this.filelist = undefined;
      }
    });
  }

  getForm(id) {
    this.formService.getForm(id)
    .subscribe(
    data => {
      this.jobsOffer.form = data.forms[0];
      this.jobsOffer.form_id = data.forms[0].id;
      this.total = data.pagination.total;
    },
    error => {
      if (error.status == 404) {
        this.forms = undefined;
      } else {
        console.log(error);
        this.forms = undefined;
      }
    });
  }

  getListFile(id) {
    this.filesService.getList(id)
    .subscribe(
    data => {
      this.jobsOffer.filelist = data.doclists[0];
      this.jobsOffer.filelist_id = data.doclists[0].id;
      this.totalfl = data.pagination.total;
    },
    error => {
      if (error.status == 404) {
        this.filelist = undefined;
      } else {
        console.log(error);
        this.filelist = undefined;
      }
    });
  }

  getEducationLevel() {
    this.educationLevelService.get()
      .subscribe(
        data => {
          this.educationLevel = data;
        },
        error => this.errorMessage = <any>error
      );
  }

  getContractType() {
    this.contractTypeService.get()
      .subscribe(
        data => {
          this.contractType = data;
        },
        error => this.errorMessage = <any>error
      );
  }

  getJobType() {
    this.jobTypeService.getJobType()
      .subscribe(
        data => {
          this.jobType = data;
        },
        error => this.errorMessage = <any>error
      );
  }

  getLanguageName() {
    this.languageNameService.getNames()
      .subscribe(
        data => {
          this.languageName = data;
        },
        error => this.errorMessage = <any>error
      );
  }

  getLanguageLevel() {
    this.languageLevelService.getLevels()
      .subscribe(
        data => {
          this.languageLevel = data;
        },
        error => this.errorMessage = <any>error
      );
  }

  getValueKey (obj,key) {
    for (let i = 0; i < obj.length; ++i) {
      if (obj[i].id === key) {
        return obj[i].name;
      }
    }
    return '';
  }

  getValueKey2 (obj,key) {
    for (let i = 0; i < obj.length; ++i) {
      if (obj[i].id === key) {
        return obj[i].name;
      }
    }
    return '';
  }



  initOffer() {
    this.jobsOffer = {
      id: '',
      title: '',
      contracttype_id: 0,
      jobcategory_id: 0,
      educationlevel_id: 0,
      venue_id: "",
      jobtype_id: 0,
      country: '',
      description: '',
      request: '',
      quantity: undefined,
      language: 0,
      languageLevel: 0,
      languages: {},
      requirements: {},
      travel: false,
      impairment: 0,
      expired_at: '',
      published_at: '',
      expired_at1: '',
      published_at1: '',
      requisition_id: '',
      englishLevel: false,
      car: 0,
      experience: false,
      salary: undefined,
      salary_range: 0,
      salary_additional: '',
      min_age: 0,
      max_age: 0,
      gender: 0,
      move: false,
      salary_noshow: false,
      status: 1,
      state: 1,
      applications: 0,
      views: 0,
      report:null,
      users_selected:0,
      private: false,
      premium: 0,
      urgent: 0,
      files: 0,
      form: [],
      filelist: [],
      form_id: 0,
      filelist_id:0,
      available_invitation:0,
      company: {
        logo: '',
        name: '',
      },
      educationlevel: {
        id: undefined,
        name: '',
      },
      venue: {
        id: undefined,
        name: '',
        address: '',
        country: {
          name: '',
        },
        countryAdmin1: {
          name: '',
        },
        countryAdmin2: {
          name: '',
        },
        lat: 0,
        lng: 0,
      },
      contracttype: {
        id: undefined,
        name: '',
      },
      jobcategory: {
        id: undefined,
        name: '',
      },
      jobtype: {
        id: undefined,
        name: '',
      },
    };
    this.listLang = [];
    this.listExtras = [];
  }

  getOffers(id) {
    this.jobService.getOffersById(id)
      .subscribe(
        data => {
          this.jobsOffer = data;
          this.jobsOffer.venue_id = this.jobsOffer.venue.id;
          this.jobsOffer.jobcategory_id = this.jobsOffer.jobcategory.id;
          this.jobsOffer.contracttype_id = this.jobsOffer.contracttype.id;
          this.jobsOffer.jobtype_id = this.jobsOffer.jobtype.id;
          this.jobsOffer.educationlevel_id = this.jobsOffer.educationlevel.id;
          this.jobsOffer.files = this.jobsOffer.filelist;

          //TODO: remove uuid and use id as uuid
          if (this.jobsOffer.form.length > 0) {
            this.getForm(this.jobsOffer.form[0].uuid);
          }

          if (this.jobsOffer.filelist.length > 0) {
            this.getListFile(this.jobsOffer.filelist[0].uuid);
          }

          if (this.jobsOffer.requirements.length > 0) {
            this.listExtras = this.jobsOffer.requirements;
          }

          if (this.jobsOffer.languages.length > 0) {
            this.listLang = this.jobsOffer.languages;
          }

          if (this.jobsOffer.salary_range>0) {
            this.statusSalary = 2;
          }

          if (!this.view) {
            let date = new Date();
            this.jobsOffer.published_at1 = {
              date: {
                  year: date.getFullYear(),
                  month: date.getMonth() + 1,
                  day: date.getDate()}
              };
            date.setHours(date.getHours() + 720);

            this.jobsOffer.expired_at1 = {
              date: {
                  year: date.getFullYear(),
                  month: date.getMonth() + 1,
                  day: date.getDate()}
              };
          } else {
            let date = new Date(this.jobsOffer.published_at);
            this.jobsOffer.published_at1 = {
              date: {
                  year: date.getFullYear(),
                  month: date.getMonth() + 1,
                  day: date.getDate()}
              };
            date = new Date (this.jobsOffer.expired_at);

            this.jobsOffer.expired_at1 = {
              date: {
                  year: date.getFullYear(),
                  month: date.getMonth() + 1,
                  day: date.getDate()}
              };
          }

          this.listLang = [];

          if(this.jobsOffer.languages) {
            for (let i = 0; i < this.jobsOffer.languages.length; ++i) {
              const lang = this.jobsOffer.languages[i];

              this.listLang.push({
                languagename_id: lang.languagename_id,
                name: lang.name,
                languagelevel_id: lang.languagelevel_id,
                level: lang.level
              });
            }
          }
        },
        error => this.errorMessage = <any>error
      );
  }

  openDialogVenue(sendData) {
    let dialogRef = this.dialog.open(MapComponent);

    if (sendData) {
      dialogRef.componentInstance.venue_id = this.jobsOffer.venue.id;
      dialogRef.componentInstance.venue_name = this.jobsOffer.venue.name;
      dialogRef.componentInstance.venue_lat = this.jobsOffer.venue.lat;
      dialogRef.componentInstance.venue_lng = this.jobsOffer.venue.lng;
      dialogRef.componentInstance.venue_address = this.jobsOffer.venue.address;
      dialogRef.componentInstance.sendData = sendData;
    }

    dialogRef.afterClosed().subscribe(result => {
      console.log(result);
      if (result != undefined){
        this.jobsOffer.venue = result;
        this.jobsOffer.venue_id = result.id;
        this.jobsOffer.venue.name = result.name;
      }
      // this.getVenues();
    });
  }


  openDialogForm (name,id) {
      let dialogRef = this.dialog.open(FormComponent);
      dialogRef.afterClosed().subscribe(result => {
        if (result != 'yes' && result != undefined) {
          this.jobsOffer.form = result.form;
          this.searchForm();
          this.getForm(this.jobsOffer.form[0].id);
        }
      });
      dialogRef.componentInstance.nameComponent = name;
      dialogRef.componentInstance.FormID = id;
      dialogRef.componentInstance.Forms = this.forms;
  }

  openDialogFiles (name,id) {
    let dialogRef = this.dialog.open(FilesComponent);
    dialogRef.afterClosed().subscribe(result => {
      if (result != 'yes' && result != undefined) {
        console.log(result);
        this.jobsOffer.filelist = result.doclist;
        this.searchFileList();
        this.getListFile(this.jobsOffer.filelist[0].id);
      }
    });
    dialogRef.componentInstance.nameComponent=name;
    dialogRef.componentInstance.FileID=id;
    dialogRef.componentInstance.Files=this.forms;
}

searchFileList(page?: number) {
    if(page == null) {
      page = 1;
    }

    this.filesService.getDoclists(page, this.max)
    .subscribe(
    data => {
      this.filelist = data.doclists;
      this.page = data.pagination.pages;
      this.totalfl = data.pagination.total;
    },
    error => {
      if (error.status == 404) {
        this.forms = undefined;
      } else {
        console.log(error);
        this.forms = undefined;
      }
    });
  }

  searchForm(page?: number) {
    if(page == null) {
      page = 1;
    }

    this.formService.getForms(page, this.max)
    .subscribe(
    data => {
      this.forms = data.forms;
      this.page = data.pagination.pages;
      this.total = data.pagination.total;
    },
    error => {
      if (error.status == 404) {
        this.forms = undefined;
      } else {
        console.log(error);
        this.forms = undefined;
      }
    });
  }

  setVenue(id) {
    this.jobsOffer.venue_id = id;
    this.jobsOffer.venue.name = this.getValueKey2(this.venues,this.jobsOffer.venue.id);
      for (let i = 0; i < this.venues.length; ++i) {
        if (this.venues[i].id === id) {
          this.jobsOffer.venue.lat = this.venues[i].lat;
          this.jobsOffer.venue.lng = this.venues[i].lng;
          this.jobsOffer.venue.address = this.venues[i].address;
        }
      }
  }

  onRegister() {
    this._router.navigate(['register'])
  }

  onRecoveryPassword() {
    this._router.navigate(['recovery'])
  }

  onPostLogin() {
    this._router.navigate(['dashboard'])
  }

  switchRegister() {
    this.register === true ? this.register = false : this.register = true;
  }

  addLang() {
    if (!this.jobsOffer.language || !this.jobsOffer.languageLevel) {
      return;
    }

    let index = -1;
    for (let _i = 0; _i < this.listLang.length; _i++) {
      if (this.listLang[_i].name_id == this.jobsOffer.language) {
        index = _i;
        break;
      }
    }

    if (index > -1) {
      alert("El idioma ya esta registrado.");
      return;
    }

    let langName: string;
    for (let i = 0; i < this.languageName.length; ++i) {
      if (this.languageName[i].id == this.jobsOffer.language) {
        langName = this.languageName[i].name;
        break;
      }
    }

    let langLevel: string;
    for (let i = 0; i < this.languageLevel.length; ++i) {
      if (this.languageLevel[i].id == this.jobsOffer.languageLevel) {
        langLevel = this.languageLevel[i].name;
        break;
      }
    }

    this.listLang.push({
      languagename_id: this.jobsOffer.language,
      name: langName,
      languagelevel_id: this.jobsOffer.languageLevel,
      level: langLevel
    });

    this.jobsOffer.language = 0;
    this.jobsOffer.languageLevel = 0;
  }

  removeLang(elm) {
    let index = -1;

    for (let _i = 0; _i < this.listLang.length; _i++) {
      if (this.listLang[_i].languagename_id == elm) {
        index = _i;
        break;
      }
    }

    if (index > -1) {
      this.listLang.splice(index, 1);
    }
  }

  addExtras() {
    if (!this.textExtra || !this.requiredExtra) {
      return;
    }

    this.listExtras.push({
      mandatory: this.requiredExtra,
      description: this.textExtra
    });

    this.textExtra = "";
    this.requiredExtra = false;
  }

  removeExtras(elm) {
    let index = -1;

    for (let _i = 0; _i < this.listExtras.length; _i++) {
      if (this.listExtras[_i].text == elm) {
        index = _i;
        break;
      }
    }

    if (index > -1) {
      this.listExtras.splice(index, 1);
    }
  }

  getRequiredName(id) {
    if (id == "1") {
      return "Obligatorio";
    } else if (id == "0") {
      return "Deseable";
    } else {
      return "Desconocido";
    }
  }

  onPostPublicationCheck() {
    this.addExtras();
    this.addLang();

    this.publicating = true;

    let month = ("0" + (this.date.getMonth() + 1)).slice(-2);
    let month2 = ("0" + (this.date2.getMonth() + 1)).slice(-2);
    let day = ("0" + (this.date.getDate())).slice(-2);
    let day2 = ("0" + (this.date2.getDate())).slice(-2);
    this.jobsOffer.published_at = this.date.getFullYear()+"-"+month+"-"+day;
    this.jobsOffer.expired_at = this.date2.getFullYear()+"-"+month2+"-"+day2;

    this.jobsOffer.languages = this.listLang;
    this.jobsOffer.requirements = this.listExtras;

    if (this.jobsOffer.status) {
      this.jobsOffer.state = 1;
      this.jobsOffer.status = 1;
    } else {
      this.jobsOffer.state = 0;
      this.jobsOffer.status = 1;
    }

    if (this.jobsOffer.premium) {
      this.jobsOffer.premium = 1;
    } else {
      this.jobsOffer.premium = 0;
    }

    if (this.jobsOffer.urgent) {
      this.jobsOffer.urgent = 1;
    } else {
      this.jobsOffer.urgent = 0;
    }

    if (this.jobsOffer.min_age === undefined || this.jobsOffer.min_age === null) {
      this.jobsOffer.min_age = 0;
    }

    if (typeof this.reqId != 'undefined') {
      this.jobsOffer.requisition_id = this.reqId;
    }
    if (this.jobsOffer.max_age === undefined || this.jobsOffer.max_age === null) {
      this.jobsOffer.max_age = 0;
    }

    this.jobService.postOffers(this.jobsOffer)
       .subscribe(
         data => {
           this.publicating = false;
           this.dialog.open(MessageBoxDialog, {data: {message: 'Oferta Publicada', success: true, showIcon:true}});
           this.initOffer();
           this.searchTransactions();
           this._router.navigate(['listofferpremium']);
         },
         error => {
           console.log(error);
           this.dialog.open(MessageBoxDialog, {data: {title: 'No se pudo crear la Oferta', message: 'Verifique los datos de la oferta: ' + error, alert: true, showIcon:true}});
           this.publicating = false;
           this.searchTransactions();
          }
     );
  }

  onPostPublication() {

    // colocar un modal
    //this.dialog.open(MessageBoxDialog, {data: {message: 'Oferta Publicada', success: true, showIcon:true}});
    let dialogRef = this.dialog.open(MessageBoxCheckDialog);
    dialogRef.componentInstance.checkingData = true;
    dialogRef.componentInstance.message = "Las ofertas no se pueden editar, revisa la oferta antes de continuar.";
    dialogRef.afterClosed().subscribe(result => {
      if (result == true){
        this.onPostPublicationCheck();
      }
      //this.onPostPublicationCheck();
    });

  }

  getTypeName(id) {
    if (id == "1") {
      return "Selección Simple (S/N)";
    } else if (id == "2") {
      return "Texto (Máx 140 caractéres)";
    } else if (id == "3") {
      return "Selección Simple (A,B,C,D)";
    } else if (id == "4") {
      return "Selección Multiple (A,B,C,D)";
    } else {
      return "Desconocido";
    }
  }

  // onChangePremium(premium) {
  //   if (premium) {
  //     this.jobsOffer.premium = 1;
  //   } else {
  //     this.jobsOffer.premium = 0;
  //   }
  // }

  openDialogPaymentCredits() {
    let dialogRef = this.dialog.open(PaymentDialogComponent);
    dialogRef.afterClosed().subscribe(result => {
      this.searchTransactions();
    });
  }

  getTotalInvitations() {
    let total = 0;
    this.transactions.forEach(element => {
      total += Number(element.order_package.invitation.invitation);
    });
    return total;
  }

  getVenueInvalid() {
    if (this.jobsOffer.venue.name === null || this.jobsOffer.venue.name === '') {
      return true;
    } else {
      return false;
    }
  }

  getInvalidVacancy() {
    if (this.jobsOffer.quantity) {
      if (Number(this.jobsOffer.quantity) > this.totalTransactions) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  }


}



// WEBPACK FOOTER //
// /var/www/_deploy/front-company-testing/2018-09-30-21-57-10/src/app/pages/create-offer/create-offer.component.ts